import { render, staticRenderFns } from "./blogCategorySlider.vue?vue&type=template&id=18b14175"
import script from "./blogCategorySlider.vue?vue&type=script&lang=js"
export * from "./blogCategorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports